
























import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class InfoIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#92A2B0' }) readonly fill?: string;
}
